import { defaultMenuState, MENUSTATE } from '.'
import { getMenuState } from './getState'

const setMenuState = (updates) => {
    MENUSTATE.menu = { ...MENUSTATE.menu, ...updates }
}

export const setMenuIDState = (id: number) => {
    setMenuState({ id })
}

export const setMenuMuteState = (mute: boolean) => {
    setMenuState({
        persist: {
            ...MENUSTATE.menu.persist,
            mute,
        },
    })
}

export const resetMenuState = () => {
    const menuState = getMenuState()
    const persist = menuState?.persist
    setMenuState({ ...defaultMenuState, persist })
}
